module.exports = __webpack_public_path__ + "static/media/auth_1.png";